<template>
  <div class="question border4">
    <div>
      <span class="time">{{ dateFormat(item.createTime) }}</span>
      <span class="number">问题编号：{{ item.orderIdStr }}</span>
    </div>

    <h3>{{ JSON.parse(item.content)[0].text }}</h3>

    <div class="info">
      <template v-if="item.doctorId">
        <img class="head" :src="item.cyDoctor.image" alt="">
        <span class="name">{{ item.cyDoctor.name }}</span>
        <span class="job border3">{{ item.cyDoctor.clinic }}</span>
      </template>

      <span v-if="isDelete" class="delete icon-delete" @click="deleteQuestion(item.id)" data-track="yy_djk_kwys_sc"></span>
      <span class="status" :class="typesClass" :style="{ color: color }">{{ statusText }}</span>
    </div>
  </div>
</template>

<script>
  import {isColor} from '../assets/utils';

  export default {
    name: 'question',
    props: {
      item: {},
      status: {},
      color: {
        validator(value) {
          let colorFlag = true;
          if (!value) {
            colorFlag = true;
          } else {
            colorFlag = isColor(value);
          }
          return colorFlag;
        }
      }
    },
    created() {
      // 发埋点
      if (window.Tracking && typeof window.Tracking.initTrackUrl === 'function') {
        window.Tracking.initTrackUrl(2, 'djk_kwys_wdfw_question_show', '');
      }
    },
    computed: {
      typesClass() {
        switch (this.status) {
          case 0:
            // 未支付
            return 'status-no';
          case 1:
            // 已支付
            if (this.item.unReadMessage > 0) {
              return 'status-new';
            } else if (this.item.doctorAnwer === 0) {
              return 'status-ing';
            }
            return 'status-ing';
          case 2:
            // 已关闭
            return 'status-close';
          case 3:
            // 已退款
            return 'status-refund';
          case 4:
            // 异常关闭
            return 'status-close';
          case 5:
            // 支付失效
            return 'status-close';
          default:
            return 'status-close';
        }
      },
      statusText() {
        switch (this.status) {
          case 0:
            // 未支付
            return '未支付';
          case 1:
            // 已支付
            if (this.item.doctorId && this.item.unReadMessage === 0 && this.item.doctorAnwer === 0) {
              return '待医生回复';
            }
            if (this.item.doctorId && this.item.unReadMessage === 0 && this.item.doctorAnwer === 1) {
              return '进行中';
            }
            if (this.item.unReadMessage > 0) {
              return '有新消息';
            }
            return '新问题';
          case 2:
            // 已关闭
            return '已关闭';
          case 3:
            // 已退款
            return '已退款';
          case 4:
            // 异常关闭
            return '已关闭';
          case 5:
            // 支付失效
            return '问题失效';
          default:
            return '已关闭';
        }
      },
      isDelete() {
        if (this.status === 0 || this.status === 2 || this.status === 3 || this.status === 4 || this.status === 5) {
          return true;
        }
        return false;
      }
    },
    methods: {
      deleteQuestion(id) {
        if (window.Tracking && typeof window.Tracking.initTrackUrl === 'function') {
          // window.Tracking.initTrackUrl(2, 'yy_djk_kwys_sc_alert_show', '');
          window.Tracking.initTrackUrl(2, 'yy_djk_kwys_sc_alert_show', '');
        }
        this.$dialog.Confirm({
          mes: '确定删除问题吗！',
          opts: [
            {
              txt: '取消',
              color: false,
              track: 'yy_djk_kwys_qxsc',
              callback: () => {
              }
            },
            {
              txt: '确定',
              color: true,
              track: 'yy_djk_kwys_qrsc',
              callback: () => {
                this.$store.dispatch('deleteQuestion', {
                  interrogationid: id
                }).then((v) => {
                  if (v.err) {
                    this.$dialog.Toast({mes: v.err});
                    return false;
                  }
                  this.$dialog.Toast({mes: '删除成功'});
                  setTimeout(() => {
                    location.reload();
                  }, 1000);
                  return true;
                });
              }
            }
          ]
        });
      },

      // 格式化日期
      dateFormat(numbers, type) {
        if (!numbers) {
          numbers = (new Date()).getTime();
        }
        const date = new Date(Number(numbers));
        const year = date.getFullYear();
        const month = this.fillNumber(date.getMonth() + 1);
        const day = this.fillNumber(date.getDate());
        const hours = this.fillNumber(date.getHours());
        const minutes = this.fillNumber(date.getMinutes());
        let result = '';
        switch (type) {
          case 'YYYY年MM月DD日':
            result = `${year}年${month}月${day}日`;
            break;
          case 'MM月DD日 HH:MM':
            result = `${month}月${day} ${hours}:${minutes}`;
            break;
          case 'HH:MM':
            result = `${hours}:${minutes}`;
            break;
          default:
            result = `${month}-${day} ${hours}:${minutes}`;
            break;
        }
        return result;
      },

      // 格式化为两位数字，如果为 1 则格式化为01
      fillNumber(number) {
        if (number < 0) {
          number = 0;
        }
        return number > 9 ? number : `0${number}`;
      },

      stopEvent() {
        return false;
      }
    }
  };
</script>

<style lang="less" rel="stylesheet/less" scoped>
  @import "../assets/base.less";

  .question {
    padding: 30px 0;

    > div:first-child {
      width: 100%;
      height: 24px;
      line-height: 24px;
      margin-bottom: 28px;
      color: rgb(170, 170, 170);
      font-size: 24px;

      .number {
        float: right;
      }
    }

    h3 {
      line-height: 48px;
      font-size: 32px;
      font-weight: 500;
      .line-clamp(2, 48px);
    }

    .info {
      height: 60px;
      line-height: 60px;
      margin-top: 20px;

      img {
        float: left;
        display: inline-block;
        width: 60px;
        height: 60px;
        border-radius: 100%;
      }

      span.name {
        display: inline-block;
        color: @color-blue;
        padding: 0 16px 0 20px;
        font-size: 24px;
      }

      span.job {
        display: inline-block;
        height: 34px;
        line-height: 34px;
        padding: 0 10px;
        border-radius: 6px;
        color: rgb(208, 208, 208);
        font-size: 22px;
      }

      span.status {
        float: right;
        display: inline-block;
        text-align: right;
        color: rgb(208, 208, 208);
        font-size: 28px;
      }

      span.status-new {
        position: relative;
        color: @color-red;
      }

      span.status-new:before {
        position: absolute;
        top: 24px;
        right: 120px;
        content: '';
        width: 10px;
        height: 10px;
        border-radius: 100%;
        background-color: @color-red;
      }

      span.status-close {
        color: rgb(208, 208, 208);
      }

      span.status-refund {
        color: rgb(136, 136, 136);
      }

      span.status-no {
        color: @color-blue-light;
      }

      span.status-ing {
        color: @color-main;
      }

      span.delete {
        float: right;
        margin-left: 5px;
        display: inline-block;
        width: 74px;
        text-align: right;
        color: rgb(136, 136, 136);
        font-size: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Question.vue?306af662